<button [type]="type" [ngClass]="cssClasses">
  <ng-content></ng-content>
</button>
